import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { Arrow } from '../Icons';
import * as styles from './ArrowButton.css';

export interface IArrowButtonProps {
  direction: 'left' | 'right';
  onClick(): void;
}

export function ArrowButton({ direction, onClick }: IArrowButtonProps) {
  return (
    <button {...mergeStyles(styles['arrow_button'], styles[`arrow_button--${direction}`])} onClick={onClick}>
      <Arrow />
    </button>
  );
}
